import React, { useEffect, useState, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import de from "date-fns/locale/de";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import axios from 'axios';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
  IconButton,
  Grid,
} from "@material-ui/core";


import CloseIcon from '@material-ui/icons/Close';

import { PageContext } from "../../../contexts/PageContext";
import { UserContext } from "../../../contexts/UserContext";


const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  descriptionPaper: theme.descriptionPaper,
}));

export default function ArchiveStatsDialog(
  {
    credit,
    open,
    setOpen,
  }) {
  const theme = useTheme();
  const classes = useStyles();
  const [fixzins, setFixzins] = useState(0.0);
  const [aufschlagVariabel, setAufschlagVariabel] = useState(0.0);
  const [fixzinsEndDate, setFixzinsEndDate] = useState(null);
  const [remainingMonthsFixzins, setRemainingMonthsFixzins] = useState(null);
  const [creditEndDate, setCreditEndDate] = useState(null);
  const [remainingMonthsCredit, setRemainingMonthsCredit] = useState(null);

  const userContext = useContext(UserContext);
  const pageContext = useContext(PageContext);
  useEffect(() => {
    if (credit) {
      setFixzins(credit.stats.fixzins);
      setAufschlagVariabel(credit.stats.aufschlag_variabel);

      const today = new Date();
      if (credit.stats.fixzins_end_date) {
        const newFixzinsEndDate = new Date(credit.stats.fixzins_end_date);
        setFixzinsEndDate(newFixzinsEndDate);
        const newRemainingMonthsFixzins = (newFixzinsEndDate.getFullYear() - today.getFullYear()) * 12 + newFixzinsEndDate.getMonth() - today.getMonth();
        setRemainingMonthsFixzins(newRemainingMonthsFixzins);
      } else {
        setFixzinsEndDate(null);
      }

      if (credit.stats.credit_end_date) {
        const newCreditEndDate = new Date(credit.stats.credit_end_date);
        setCreditEndDate(newCreditEndDate);
        const newRemainingMonthsCredit = (newCreditEndDate.getFullYear() - today.getFullYear()) * 12 + newCreditEndDate.getMonth() - today.getMonth();
        setRemainingMonthsCredit(newRemainingMonthsCredit);
      } else {
        setCreditEndDate(null);
      }

    }
  }, [credit]);

  const saveCreditStats = () => {
    const stats = {
    }
    if (!isNaN(parseFloat(fixzins))) {
      stats.fixzins = parseFloat(fixzins);
    }
    if (!isNaN(parseFloat(aufschlagVariabel))) {
      stats.aufschlag_variabel = parseFloat(aufschlagVariabel);
    }
    if (fixzinsEndDate) {
      stats.fixzins_end_date = fixzinsEndDate;
    }
    if (creditEndDate) {
      stats.credit_end_date = creditEndDate;
    }
    const currentStatus = credit.status;

    const saveData = { ...credit, stats: stats, status: "successful" };
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${credit.id}`,
      data: saveData,
      method: 'put',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        if (currentStatus !== "successful") {
          pageContext.setInfoMessage("Finanzierung wurde archiviert. Du findest sie rechts oben im Archiv-Tab.");
        } else {
          pageContext.setInfoMessage("Finanzierung wurde aktualisiert.");
        }
        setOpen(false);
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("Finanzierung konnte nicht gespeichert werden!");
      });
  }




  return (
    <>
      <Dialog
        onClose={() => { setOpen(false) }}
        open={open}
        fullWidth={true}
        maxWidth="md">
        <DialogTitle>
          Ergebnisse
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item >
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
                <DatePicker
                  fullWidth
                  disableToolbar
                  variant="inline"
                  format="MMMM yyyy"
                  inputFormat="MMMM yyyy"
                  openTo="year"
                  margin="none"
                  label="Fixzins bis"
                  value={fixzinsEndDate ? fixzinsEndDate : null}
                  onChange={(value) => {
                    if (value) {
                      const newFixzinsEndDate = new Date(value);
                      // set first day of month
                      newFixzinsEndDate.setDate(1);
                      setFixzinsEndDate(newFixzinsEndDate);
                    } else {
                      setFixzinsEndDate(null);
                    }
                  }}
                  autoOk={true}
                  invalidDateMessage={"ungültiges Datumsformat"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  slotProps={{
                    textField: {
                      variant: 'standard',
                    },
                  }}
                  views={['year', 'month']}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item >
              <TextField
                label="Fixzins"
                type="number"
                value={fixzins ? fixzins : ""}
                onChange={(e) => {
                  setFixzins(e.target.value);
                }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
                style={{ width: 150 }}
              />
            </Grid>
            <Grid item>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
                <DatePicker
                  fullWidth
                  disableToolbar
                  variant="inline"
                  format="MMMM yyyy"
                  inputFormat="MMMM yyyy"
                  openTo="year"
                  margin="none"
                  label="Gesamtlaufzeit bis"
                  value={creditEndDate ? creditEndDate : null}
                  onChange={(value) => {
                    if (value) {
                      const newCreditEndDate = new Date(value);
                      // set first day of month
                      newCreditEndDate.setDate(1);
                      setCreditEndDate(newCreditEndDate);
                    } else {
                      setCreditEndDate(null);
                    }
                  }}
                  autoOk={true}
                  invalidDateMessage={"ungültiges Datumsformat"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  slotProps={{
                    textField: {
                      variant: 'standard',
                    },
                  }}
                  views={['year', 'month']}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item>
              <TextField
                label="Aufschlag variabel"
                type="number"
                value={aufschlagVariabel ? aufschlagVariabel : ""}
                onChange={(e) => {
                  setAufschlagVariabel(e.target.value);
                }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
                style={{ width: 150 }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              saveCreditStats();
            }}
            color="primary"
            variant="contained"
            autoFocus>
            Speichern
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            // color="primary"
            // variant="contained"
            autoFocus>
            abbrechen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
